import Vue from 'vue'
import translator from '@/global/localisation/translator'
import '@/global/lintax/lintax'
import dejaVue from '@/global/dejaVue/dejaVue'
import Database from '@/domain/database'
import loader from '@/global/loader/loader'
import Francais from '@/translations/fr'
import Translation from '@/translations/translation'
import requester from '@/global/requesting/requester'
import Configuration from '@/configuration/configuration'
import router from '@/router/core'
import ROUTE from '@/router/routeEnum'

import '@/global/extensions/string.extensions'
import '@/global/extensions/number.extensions'
import '@/global/extensions/date.extensions'
import swal from '@/plugins/swal/swal'

Vue.use(loader)
Vue.use(translator<Translation>(Configuration.defaultLanguageCode, new Francais()))
Vue.use(dejaVue(new Database()))
Vue.use(
    requester(`${Configuration.apiUrl}/api`, () => {
        Vue.prototype.$database.clear()
        // Vue.prototype.$database.save();
        Vue.prototype.$auth.logout()
        router.push({ name: ROUTE.AUTH })
    })
)
Vue.use(swal)
